import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { Box, Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import styles from './styles';

export default function PaymentCard({ modalOpenButton, imgs }) {
  const isSm = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Paper elevation={0} sx={styles.card}>
      <Typography variant={'desktopH3'} color="kit.text.h">
        Платите частями
      </Typography>
      <Typography variant={'desktopH3'} color="kit.text.h">
        через наших парнеров
      </Typography>

      <Grid item xs={12} sx={styles.paymentItem}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Typography variant="desktopP1">12-36 месяцев&nbsp;</Typography>
          <Typography
            variant="desktopP3"
            color="kit.text.secondary"
            alignSelf="center"
          >
            (можно погасить досрочно)
          </Typography>
        </Box>
        <Box sx={styles.banksContainer}>
          <Box
            sx={{
              width: isSm ? '90px' : '132px',
              height: isSm ? '35px' : '52px',
            }}
          >
            <GatsbyImage
              image={getImage(imgs['payment/tbank'])}
              alt=""
              loading="lazy"
            />
          </Box>
          <Box
            sx={{
              width: isSm ? '96px' : '132px',
              height: isSm ? '20px' : '29px',
            }}
          >
            <GatsbyImage
              image={getImage(imgs['payment/renessans'])}
              alt=""
              loading="lazy"
            />
          </Box>
          <Box
            sx={{
              width: isSm ? '90px' : '116px',
              height: isSm ? '26px' : '34px',
            }}
          >
            <GatsbyImage
              image={getImage(imgs['payment/otp'])}
              alt=""
              loading="lazy"
            />
          </Box>
        </Box>
        {!isSm && <Box sx={{ mt: 5 }}>{modalOpenButton}</Box>}
      </Grid>
    </Paper>
  );
}
